<template>
  <el-dialog
    width="40%"
    class="dialog"
    title="批量发放确认"
    :visible.sync="dialogFormVisible"
  >
    <div class="dialog-content">
      批量发放将导出全部待发放的补贴，点击确认后开始导出
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitBtnFun"
        >确认</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      dialogFormVisible: false,
      btnLoading: false
    };
  },
  watch: {},
  computed: {},
  watch: {},
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dialogFormVisible = false;
    },
    // 打开弹框
    async openDialog(id) {
      this.orderNo = id;
      this.dialogFormVisible = true;
    },
    // 确认审核通过
    submitBtnFun() {
      this.dialogFormVisible = false;
      this.global
        .exportExcel(
          `/autoapp-default-server-recovery/api/oldMachineSubsidy/subsidyIssuedOperateBatch`,
          {},
          "批量发放数据"
        )
        .then(res => {
          if (res === true) {
            this.$emit("batchDistributionFinished");
          }
        })
        .catch(res => {
          let blob = new Blob([res.response.data], {
            type: "application/json"
          });
          var blobReader = new Response(blob).json();
          blobReader.then(res => {
            this.$message.error(res.message);
          });
        });
    }
  }
};
</script>
<style scoped lang="scss">
.dialog {
  padding: 0 20px;
  .el-dialog__body {
    padding-top: 10px;
  }
  .dialog-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .dialog-footer {
    padding: 20px;
    padding-top: 0;
  }
  .el-form-item--small.el-form-item {
    &.read-only {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldMachineSubsidy/components/BatchDistributionDialog.vue